// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-115c3dc2] #cms-content{padding-top:0!important}.admin-toolbar[data-v-115c3dc2],.z-core-toolbar[data-v-115c3dc2]{z-index:2000!important}.admin-toolbar[data-v-115c3dc2]{display:block}.hover-povratak[data-v-115c3dc2]:hover{color:#6a6d7d;transition-duration:.5s}.dark-mode .hover-povratak[data-v-115c3dc2]:hover{color:#fff;transition-duration:.5s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
